<script setup>
import { onMounted, onBeforeUnmount } from 'vue';

import ContactDetailsContainer from 'dashboard/components-next/Contacts/Pages/ContactDetailsContainer.vue';

const props = defineProps({
  contactId: {
    type: [String, Number],
    required: true,
  },
});

const emit = defineEmits(['close']);

const close = () => emit('close');

const onKeydown = event => {
  if (event.key === 'Escape') close();
};

onMounted(() => document.addEventListener('keydown', onKeydown));
onBeforeUnmount(() => document.removeEventListener('keydown', onKeydown));
</script>

<template>
  <Teleport to="body">
    <div
      class="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-8 bg-n-alpha-black1 backdrop-blur-sm"
      @click.self="close"
    >
      <div
        class="relative flex flex-col w-full h-[90vh] max-w-7xl overflow-hidden shadow-2xl rounded-2xl bg-n-background outline outline-1 outline-n-container"
      >
        <button
          type="button"
          class="absolute z-20 flex items-center justify-center w-8 h-8 rounded-lg top-3 ltr:right-3 rtl:left-3 text-n-slate-11 hover:bg-n-alpha-2 hover:text-n-slate-12"
          :aria-label="$t('CONTACTS_LAYOUT.TABLE.CLOSE_DETAILS')"
          @click="close"
        >
          <span class="i-lucide-x size-4" />
        </button>
        <ContactDetailsContainer
          :key="contactId"
          :contact-id="contactId"
          embedded
          @close="close"
        />
      </div>
    </div>
  </Teleport>
</template>
